import * as React from 'react';

import { Button, Dialog } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-admin-learners';

const { HeadingGroup, Content, Actions } = Dialog;

export type DomainAllowlistModalProps = {
  open: boolean;
  onClose: () => void;
  onBack: () => void;
};

/**
 * Placeholder for the org-level domain-allowlist management flow (ENTADMIN-1951 scaffolding only).
 * Replaced by the real add/remove/group-scoping UI in a later Phase A task.
 */
const DomainAllowlistModal = ({ open, onClose, onBack }: DomainAllowlistModalProps) => (
  <Dialog open={open} onClose={onClose}>
    <HeadingGroup>{_t('Add your domain name(s)')}</HeadingGroup>
    <Content />
    <Actions>
      <Button variant="secondary" onClick={onBack}>
        {_t('Back')}
      </Button>
    </Actions>
  </Dialog>
);

export default DomainAllowlistModal;
